import React from 'react';
import InterpreterVideo from './InterpreterVideo';

const SidePanel: React.FC<{}> = () => (
  <InterpreterVideo remoteViewId='interpreter-remote-view-1'/>
);
export default SidePanel;
